// Fuera del componente (o arriba), así no se recrea en cada render:
export const PERMISSION_TEXTS = {
  create_and_delete_story: "Crear y eliminar historias",
  view_story: "Ver historias",
  delete_library_comment: "Eliminar comentarios de la biblioteca o posteos",
  create_eco: 'Crear posteos', 
  comment_eco: 'Comentar posteos',
};
